// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/b7b4b4f1ef9acbb1aae8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"109fad3af6319ad90523","216":"25deaccf8a34e9e84f64","217":"d5bdd307a5f733c4cb31"}[chunkId] + ".chunk.js";
};